<template>
  <svg
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    style="transition: all; animation-duration: 500ms"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M1.12994 10C0.729523 10.0143 0.35058 10.0135 0 10H1.12994C5.67893 9.83739 13 7.72041 13 0V10H1.12994Z" :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#579FBB"
    }
  }
}
</script>
